export class ContactForm {
    salutation: String;
    name: String;
    email: String;
    message: String;
    captcha: String;
}